import axios, { AxiosRequestConfig } from "axios";
import { getEnvVariable } from "../environments/env";
import { urls } from "./Urls";

export class EmailService {
  private static axios = axios.create({
    baseURL: getEnvVariable().send_email_url,
  });
  private static onyxAxios = axios.create({
    baseURL: getEnvVariable().send_onyx_email_url,
  });

  static async post(url: string, body?: FormData, config?: AxiosRequestConfig) {
    try {
      const headers: AxiosRequestConfig["headers"] = {};
  
      // Set content type to form-data if body is FormData
      if (body instanceof FormData) {
        headers["Content-Type"] = "multipart/form-data";
      }
  
      const updatedConfig: AxiosRequestConfig = {
        ...config,
        headers: { ...config?.headers, ...headers },
      };
     
      const response = await EmailService.onyxAxios.post(url, body, updatedConfig);
      if(!response?.data?.isSuccess){
        const res= await this.fallbackSendEmail(body,updatedConfig)
        return res;
      }
      return response.data;
    } catch (e) {
      try{
        const headers: AxiosRequestConfig["headers"] = {};
  
      // Set content type to form-data if body is FormData
      if (body instanceof FormData) {
        headers["Content-Type"] = "multipart/form-data";
      }
  
      const updatedConfig: AxiosRequestConfig = {
        ...config,
        headers: { ...config?.headers, ...headers },
      };
        const res= await this.fallbackSendEmail(body,updatedConfig)
        return res;
      }
      catch(fallbackError){
        EmailService.handleErrors(fallbackError);
        return Promise.reject(fallbackError);
      }
    }
  }

  static async fallbackSendEmail(body?: FormData, config?: AxiosRequestConfig) {
      try{
      const response = await EmailService.axios.post(urls.registerApplication.sendEmail, body, config);
      return response.data;
      }
      catch(fallbackError){
        EmailService.handleErrors(fallbackError);
        return Promise.reject(fallbackError);
      }
  }
  
  private static handleErrors(error: any) {
    if (error.response) {
          const errorMessage =
        error.response.data?.message ||
        "Something Went Wrong. Please Try Again";
    }
  }
}
